import { useTranslation } from 'react-i18next';

const EXPIRING_SOON_DAYS = 15;

function getDaysLeftStatus(days) {
  if (days > EXPIRING_SOON_DAYS) return 'active';
  if (days > 0) return 'pending';
  return 'declined';
}

export default function ReferralDaysLeft({ days }) {
  const { t } = useTranslation();
  const status = getDaysLeftStatus(days);
  const isExpired = status === 'declined';

  return (
    <p className={`status status--${status}`}>
      <span>{isExpired ? t('Expired') : t('days_left', { count: days })}</span>
    </p>
  );
}
